﻿var lock = false;

var userInfo = null;

var contentlist = [];

window.onload = function () {
    if ($('.top-user').length > 0) {
        userInfo = $('.top-user').data('info');
    }

    getTags();
    getThreads();
    getRecommends();
};

$(window).scroll(function () {
    // 下面这句主要是获取网页的总高度，主要是考虑兼容性所以把Ie支持的documentElement也写了，这个方法至少支持IE8
    var htmlHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    // clientHeight是网页在浏览器中的可视高度，
    var clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    // 通过判断滚动条的top位置与可视网页之和与整个网页的高度是否相等来决定是否加载内容；
    if (scrollTop + clientHeight >= htmlHeight) {
        getThreads();
    }
});

window.msgbox = function (type) {
    switch (type) {
        // 发布成功
        case 1:
            $('.messagebox').removeClass('messagebox-err');
            $('.messagebox').css('display', 'block');
            setTimeout(function () {
                $('.messagebox').css('display', 'none');
                location.reload();
            }, 2000);
            break;
        // 发布失败
        case 2:
            $('.messagebox').addClass('messagebox-err');
            $('.messagebox').css('display', 'block');
            setTimeout(function () {
                $('.messagebox').css('display', 'none');
            }, 2000);
            break;
    }
};

$(function () {
    $('.add_content').on('focus', function () {
        if ($('.add_thread.edit').length == 0) {
            $('.add_thread').addClass('edit');
        }
    });

    $('.add_content').on('blur', function () {
        if ($('.add_thread.edit').length > 0 && $('.add_content').val() == '') {
            $('.add_thread.edit').removeClass('edit');
        }
    });

    $('.add_pic').on('click', function () {
        if ($('.top .top-login').length > 0) {
            return;
        }

        if ($('.add-video-item').length > 0) {
            alert('已经上传了视频，不能再上传图片');
            return;
        }

        $('.add-video-pop').hide();
        $('.add_pic_pop').css('display', 'block');
    });

    $('.add_pic_close').on('click', function () {
        $('.add_pic_pop').css('display', 'none');
    });

    $('.add-video').on('click', function () {
        if ($('.top .top-login').length > 0) {
            return;
        }

        if ($('.added_list_item').length > 0) {
            alert('已经上传了图片，不能再上传视频');
            return;
        }

        $('.add_pic_pop').hide();
        $('.add-video-pop').show();
    });

    $('.add-video-close').on('click', function () {
        $('.add-video-pop').css('display', 'none');
    });

    $('.add_thread .btn_pub').on('click', function () {
        if ($('.top .top-login').length > 0) {
            alert('请先登录！');
            return;
        }

        if ($('.add_content').val() == '') {
            alert('请先分享点什么！');
            return;
        }

        var id = $('#nav_columns .selected .nav_name').attr('data-value');
        if (id === undefined || id == '') {
            alert('请先选择栏目！');
            return;
        }

        if (lock) {
            return;
        }
        lock = true;

        var attachments = [];
        for (var i = 0; i < $('.added_list .added_list_item .attachment_path').length; i++) {
            var info = {};
            info.name = $('.added_list .added_list_item .attachment_name')[i].value;
            info.paths = [$('.added_list .added_list_item .attachment_path')[i].value];
            attachments.push(info);
        }

        for (var i = 0; i < $('.add-video-list .video-attachment-path').length; i++) {
            var info = {};
            info.name = $('.add-video-list .video-attachment-name')[i].value;
            info.paths = [$('.add-video-list .video-attachment-path')[i].value];
            attachments.push(info);
        }

        var tags = [];
        for (var i = 0; i < $('.add_tags .add_tag input:checked').length; i++) {
            tags.push($('.add_tags .add_tag input:checked')[i].value);
        }

        var data = {
            'title': '',
            'content': $('.add_content').val(),
            'attachment_infos': attachments,
            'tags': tags
        };

        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/community/add_thread?id=' + id,
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    console.log(data);
                    msgbox(2);
                } else {
                    msgbox(1);
                }
                lock = false;
            },
            error: function (data) {
                if (data.message !== undefined) {
                    console.log(data.message);
                    msgbox(2);
                } else {
                    console.log(data);
                    msgbox(2);
                }
                lock = false;
            }
        });
    });

    $('.add_thread').on('click', function () {
        if ($('.top .top-login').length > 0) {
            showLogin();
        }
    });

    $(document).on('click', '.thread-tool-comment', function () {
        var ele = $(this).parent().parent().find('.reply-list');
        if (ele.css('display') != 'block') {
            var tid = $(this).parent().data('id');
            getReply(ele, tid);
            ele.slideDown('fast');
        } else {
            ele.slideUp('fast');
        }
    });

    $(document).on('click', '.reply-publish-textarea', function () {
        if ($('.top-login').length > 0) {
            showLogin();
        }
    });

    $(document).on('click', '.reply-publish-btn', function () {
        if ($('.top-login').length > 0) {
            showLogin();
            return;
        }

        var ele = $(this).parent().parent();
        var text = ele.find('.reply-publish-textarea').val();
        text = $.trim(text);

        if (text == '') {
            // alert('请先写点什么！');
            return;
        }

        var tid = $(this).data('id');

        var data = {
            'ref_reply_id': 0,
            'content': text,
            'attachment_infos': []
        };

        $.ajax({
            type: 'post',
            async: false,
            url: ROOT + '/community/add_reply?id=' + tid,
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (data) {
                if (data !== undefined && data.message !== undefined) {
                    console.log(data);
                    alert('发表回复失败:' + data.message);
                    return;
                } else {
                    console.log(data);
                    alert('发表回复成功！');
                    location.reload();
                }
            },
            error: function (data) {
                if (data.message !== undefined) {
                    console.log(data.message);
                    alert('发表失败:' + data.message);
                } else {
                    console.log(data);
                    alert('发表失败');
                }
            }
        });
    });

    $(document).on('click', '.picture-item', function () {
        $(this).parent().find('.picture-item').removeClass('picture-item-select');
        $(this).addClass('picture-item-select');

        var url = $(this).find('img').attr('src');
        if (url.indexOf('?') > 0) {
            url = url.substr(0, url.indexOf('?'));
        }
        url += '?w=525&h=525&s=3';

        var order = $(this).data('order');

        $(this).parent().parent().find('.picture-show').data('order', order);
        $(this).parent().parent().find('.picture-show > img').attr('src', url);
    });

    $(document).on('click', '.picture-prev', function () {
        var order = $(this).parent().find('.picture-show').data('order');
        if (order == 0) {
            return;
        }

        $(this).parent().parent().find('.picture-item').removeClass('picture-item-select');
        $(this).parent().parent().find('.picture-item-' + (order - 1)).addClass('picture-item-select');

        var url = $(this).parent().parent().find('.picture-item-' + (order - 1)).find('img').attr('src');
        if (url.indexOf('?') > 0) {
            url = url.substr(0, url.indexOf('?'));
        }
        url += '?w=525&h=525&s=3';

        $(this).parent().find('.picture-show').data('order', order - 1);
        $(this).parent().find('.picture-show > img').attr('src', url);
    });

    $(document).on('click', '.picture-next', function () {
        var order = $(this).parent().find('.picture-show').data('order');
        if (order >= $(this).parent().parent().find('.picture-item').length - 1) {
            return;
        }

        $(this).parent().parent().find('.picture-item').removeClass('picture-item-select');
        $(this).parent().parent().find('.picture-item-' + (order + 1)).addClass('picture-item-select');

        var url = $(this).parent().parent().find('.picture-item-' + (order + 1)).find('img').attr('src');
        if (url.indexOf('?') > 0) {
            url = url.substr(0, url.indexOf('?'));
        }
        url += '?w=525&h=525&s=3';

        $(this).parent().find('.picture-show').data('order', order + 1);
        $(this).parent().find('.picture-show > img').attr('src', url);
    });

    $(document).on('click', '.picture-small', function () {
        $(this).parent().parent().hide();
        $(this).parent().parent().parent().find('.thread-picture').show();
    });
    var videoObj = {}
    $(document).on('click', '.thread-picture', function () {
        var type = $(this).data('type');
        var threadId = $(this).attr('id')
        if (type == 2) {
            if (videoObj[threadId]) {
            }
            else {
                var url = $(this).data('url');
                var thumbnail_url = $(this).data('thumbnail_url')
                var videoContent = '';
                var id = 'v' + threadId.split('-')[1]
                videoContent += '<video id="' + id + '"class="video-js vjs-default-skin" controls style="min-width:500px;min-height:280px"   poster=';
                videoContent += '"' + thumbnail_url + '" >';
                videoContent += '</video>';
                $(this).html(videoContent);
                videoObj[threadId] = startPlay(url, id, true)
            }
            videoObj[threadId].on('play', function () {
                for (item in videoObj) {
                    if (threadId != item) {
                        videoObj[item].pause()
                    }
                }
            })

        } else {
            $(this).hide();
            $(this).parent().find('.picture-box').show();
        }
    });

    $(document).on('click', '.thread-tool-fav', function () {
        if ($('.top-login').length > 0) {
            showLogin();
            return;
        }

        var ele = $(this);
        var isfavor = ele.hasClass('thread-tool-fav-ed');

        var id = $(this).parent().data('id');
        var data = {
            favor: !isfavor
        };

        $.ajax({
            type: 'post',
            async: true,
            url: ROOT + '/thread/' + id + '/favor',
            data: JSON.stringify(data),
            contentType: 'application/json',
            dataType: 'json',
            success: function (result) {
                if (isfavor) {
                    ele.removeClass('thread-tool-fav-ed');
                    ele.attr('title', '收藏');
                    ele.text('收藏');
                } else {
                    ele.addClass('thread-tool-fav-ed');
                    ele.attr('title', '取消收藏');
                    ele.text('收藏');
                }
            },
            error: function (error) {
                alert(error.responseText);
            }
        });
    });

    $(document).on('click', '.thread-tool-up', function () {
        if ($('.top-login').length > 0) {
            showLogin();
            return;
        }

        var ele = $(this);
        var isLike = ele.hasClass('thread-tool-up-ed');

        var id = $(this).parent().data('id');

        if (isLike) {
            $.ajax({
                type: 'post',
                async: true,
                url: ROOT + '/thread/' + id + '/cancel-attitude',
                data: {},
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    ele.removeClass('thread-tool-up-ed');
                    ele.attr('title', '点赞');

                    var likeCount = ele.data('count');
                    likeCount = parseInt(likeCount);
                    likeCount--;
                    if (likeCount > 0) {
                        ele.data('count', likeCount);
                        ele.text(likeCount);
                    } else {
                        likeCount = 0;
                        ele.data('count', likeCount);
                        ele.text('点赞');
                    }
                },
                error: function (error) {
                    alert(error.responseText);
                }
            });
        } else {
            $.ajax({
                type: 'post',
                async: true,
                url: ROOT + '/thread/' + id + '/like',
                data: {},
                contentType: 'application/json',
                dataType: 'json',
                success: function (result) {
                    ele.addClass('thread-tool-up-ed');
                    ele.attr('title', '取消点赞');

                    var likeCount = ele.data('count');
                    likeCount = parseInt(likeCount);
                    likeCount++;
                    ele.data('count', likeCount);
                    ele.text(likeCount);
                },
                error: function (error) {
                    alert(error.responseText);
                }
            });
        }
    });

    $(document).on('click', '.thread-ex', function () {
        var ele = $(this).parent().find('.thread-content');
        if ($(this).hasClass('thread-ex-all')) {
            $(this).removeClass('thread-ex-all');
            $(this).html('展开全文&nbsp∨');

            ele.removeClass('thread-content-ex');
        } else {
            $(this).addClass('thread-ex-all');
            $(this).html('收起全文&nbsp∧');

            ele.addClass('thread-content-ex');
        }
    });
});

var page = 1;

function HTMLEnCode(str) {
    var s = '';
    if (str.length == 0) return '';
    s = str.replace(/&/g, '&gt;');
    s = s.replace(/</g, '&lt;');
    s = s.replace(/>/g, '&gt;');
    s = s.replace(/ /g, '&nbsp;');
    s = s.replace(/\'/g, '\'');
    s = s.replace(/\"/g, '&quot;');
    s = s.replace(/\n/g, '<br>');
    return s;
}

window.getThreads = function () {
    var id = $('#nav_columns .selected .nav_name').attr('data-value');
    var url = '';

    url = '/community/threads?id=' + id + '&page=' + page;

    if ($('.top .top-login').length == 0) {
        $('.add_thread').css('display', 'inline-block');
    }

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + url,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '' || !data.data) {
                return;
            }
            if (data.message !== undefined) {
                alert('操作失败:' + data.message);
                return;
            }
            if (data.data === undefined) {
                alert('操作失败:' + data);
                return;
            }

            if (data.data.length == 0) {
                $('.more').text('没有了');
                return;
            }

            var newlist = '';
            var attachments = '';
            var attachmentPic1 = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                contentlist.push(info);
                if (info.attachments === undefined || info.attachments == null || info.attachments == '') {
                    info.attachments = [];
                }
                newlist += '<div class="thread-group">';

                newlist += '<div class="thread-item">';

                newlist += '<div class="thread-user">';
                newlist += '<div class="thread-user-avatar">';
                newlist += '<img src="' + info.author_avatar_url + '?w=52&h=52&s=3" />';
                newlist += '</div>';
                newlist += '<div class="thread-user-middle">';
                newlist += '<div class="thread-user-name">' + info.author_nickname + '</div>';
                newlist += '<div class="thread-user-time">' + info.post_time + '</div>';
                newlist += '</div>';
                newlist += '<div class="thread-user-follow fo" authorid="' + info.author_id + '"></div>';
                newlist += '</div>';
                // end thread-user

                newlist += '<div style="position: relative; width: 100%;">';
                // var content = info.content;
                // content = HTMLEnCode(content);
                var content = '';

                newlist += '<div class="thread-content thread-content-' + info.id + '">' + content + '</div>';
                newlist += '<a href="/community/a?id=' + info.id + '" class="thread-link">查看全文</a>';
                newlist += '</div>';

                newlist += '<div class="thread-ex" style="display: none;">展开全文&nbsp∨</div>';

                // end content

                var tmp = info.attachments.length;

                if (tmp > 0 && tmp <= 9) {
                    newlist += '<div class="thread-picture">';
                    if (tmp == 1) {
                        newlist += '<div class="s1">';
                    } else if (tmp == 5 || tmp == 6 || tmp == 9) {
                        newlist += '<div class="s3">';
                    } else if (tmp == 2 || tmp == 3 || tmp == 4 || tmp == 7 || tmp == 8) {
                        newlist += '<div class="s4">';
                    }

                    for (var j = 0; j < tmp; j++) {
                        // newlist += '<a href="/community/a?id=' + info.id + '" target="_blank">';
                        newlist += '<div>';
                        newlist += '<img src="' + info.attachments[j] + '">';
                        newlist += '</div>';
                        if (tmp == 1) {
                            attachmentPic1 += info.attachments[j] + ',';
                        } else {
                            attachments += info.attachments[j] + ',';
                        }
                    }

                    if (tmp > 0 && tmp <= 9) {
                        newlist += '</div>';
                    }

                    newlist += '</div>';
                    // end thread-picture

                    if (tmp > 0 && tmp <= 9) {
                        var tabs = '';
                        for (var j = 0; j < tmp; j++) {
                            tabs += '<div class="picture-item picture-item-' + j + ' ' + (j == 0 ? 'picture-item-select' : '') + '" ' +
                                'data-order="0">' +
                                '<img src="' + info.attachments[j] + '">' +
                                '</div>';
                        }
                        newlist += '<div class="picture-box" style="display: none;">' +
                            '<div class="picture-view">' +
                            '<div class="picture-prev"></div>' +
                            '<div class="picture-small"></div>' +
                            '<div class="picture-next"></div>' +
                            '<div class="picture-show" data-order="0"><img src="' + info.attachments[0] + '"></div>' +
                            '</div>' +
                            '<div class="picture-tab">' + tabs + '</div>' +
                            '</div>';
                    }
                }

                if (info.flags & 1 == 1) {
                    newlist += '<div class="thread-flag fg1"></div>';
                } else if (info.flags & 2 == 2) {
                    newlist += '<div class="thread-flag fg2"></div>';
                } else if (info.flags & 4 == 4) {
                    newlist += '<div class="thread-flag fg4"></div>';
                }

                newlist += '</div>';
                // end thread-item

                newlist += '<div class="thread-tools" data-id="' + info.id + '">' +
                    '<div class="thread-tool thread-tool-fav ' + (info.favorited ? 'thread-tool-fav-ed' : '') + '" ' +
                    'title="' + (info.favorited ? '取消收藏' : '收藏') + '">'
                    + '收藏' + '</div> ' +
                    '<div class="thread-tool thread-tool-comment" title="回复">'
                    + (info.reply_count > 0 ? info.reply_count : '回复') + '</div> ' +
                    // '<div class="thread-tool thread-tool-share" title="分享">'
                    // + '分享' + '</div> ' +
                    '<div class="thread-tool thread-tool-up ' + (info.attitude == 1 ? 'thread-tool-up-ed' : '') + '" ' +
                    'title="' + (info.attitude == 1 ? '取消点赞' : '点赞') + '" data-count="' + info.like_count + '">'
                    + (info.like_count > 0 ? info.like_count : '点赞') + '</div> ' +
                    '<div class="thread-tool thread-tool-jubao" title="举报" data-id="' + info.id + '" data-title="">举报</div> ' +
                    '</div>';

                var publishimg = '';
                if (userInfo
                    && typeof (userInfo.avatar_url) != 'undefined'
                    && userInfo.avatar_url
                    && userInfo.avatar_url.length > 0) {
                    publishimg = userInfo.avatar_url + '?w=35&h=35&s=1';
                }

                newlist += '<div class="reply-list" style="display: none;">' +
                    '   <div class="reply-publish">' +
                    '      <div class="reply-publish-top">' +
                    '          <div class="reply-publish-user">' +
                    (publishimg.length == 0 ? '<img src="' + publishimg + '" />' : '') +
                    '</div>' +
                    '          <div class="reply-publish-text"><textarea class="reply-publish-textarea"></textarea></div>' +
                    '      </div>' +
                    '      <div class="reply-publish-bottom">' +
                    '          <div class="reply-publish-btn" data-id="' + info.id + '"></div>' +
                    '      </div>' +
                    '   </div>' +
                    '</div>';

                newlist += '</div>';
            }

            $('.threads_list').append(newlist);

            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                $('.thread-content-' + info.id)[0].innerText = (info.content);
            }

            for (var n = 0; n < $('.thread-item').length; n++) {
                var cont = $('.thread-item').eq(n).find('.thread-content')[0];
                // console.log(cont);
                // console.log(cont.offsetHeight);
                // console.log(cont.scrollHeight);
                if (cont.offsetHeight + 1 < cont.scrollHeight) {
                    $('.thread-item').eq(n).find('.thread-ex').show();
                }

            }

            getAttachment(attachments);
            getAttachment(attachmentPic1, 286, 286);

            // if (data.data.length < 5) {
            //     $('.more').css('display', 'none');
            // }

            $('.more').text('加载更多');

            page++;

            $('.thread-user-follow').off('click');
            $('.thread-user-follow').on('click', function () {
                if ($('.top .top-login').length > 0) {
                    showLogin();
                    return;
                }

                var tmp = $(this);
                if (tmp.hasClass('fo')) {
                    $.ajax({
                        type: 'post',
                        async: false,
                        url: ROOT + '/user/follow?follow=true&id=' + $(this).attr('authorid'),
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        dataType: 'json',
                        success: function (data) {
                            if (data !== undefined && data.message !== undefined) {
                                console.log(data);
                                alert('关注失败');
                            } else {
                                tmp.removeClass('fo');
                                tmp.addClass('uf');
                            }
                        },
                        error: function (data) {
                            if (data.message !== undefined) {
                                console.log(data.message);
                                alert('关注失败 ' + data.message);
                            } else {
                                console.log(data);
                                alert('关注失败');
                            }
                        }
                    });
                } else {
                    $.ajax({
                        type: 'post',
                        async: false,
                        url: ROOT + '/user/follow?follow=false&id=' + $(this).attr('authorid'),
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        dataType: 'json',
                        success: function (data) {
                            if (data !== undefined && data.message !== undefined) {
                                console.log(data);
                                alert('取消关注失败');
                            } else {
                                tmp.removeClass('uf');
                                tmp.addClass('fo');
                            }
                        },
                        error: function (data) {
                            if (data.message !== undefined) {
                                console.log(data.message);
                                alert('取消关注失败 ' + data.message);
                            } else {
                                console.log(data);
                                alert('取消关注失败');
                            }
                        }
                    });
                }
            });
            $('.left-bg').height($('.left').height());
            $('.content').css('min-height', $('.left').height());
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined) {
                alert('获取列表失败:' + data.message);
            } else {
                alert('获取列表失败:' + data);
            }
        }
    });
};

function getTags() {
    var id = $('#nav_columns .selected .nav_name').attr('data-value');

    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/community/columninfo?id=' + id,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '') {
                return;
            }
            if (data.message !== undefined) {
                console.log(data);
                return;
            }
            if (data.tags && data.tags.length > 0) {
                var html = '';
                for (var i = 0; i < data.tags.length; i++) {
                    html += '<div class="add_tag"><input type="checkbox" value="' + data.tags[i] + '" />' + data.tags[i] + '</div>\n';
                }
                $('.add_tags').html(html);
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}


var replyPage = 1;

function getReply(ele, tid) {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/community/thread_reply?tid=' + tid + '&page=' + replyPage,
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '') {
                return;
            }
            if (data.message !== undefined) {
                alert('操作失败:' + data.message);
                return;
            }
            if (data.data === undefined) {
                alert('操作失败:' + data);
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                newlist += '<div class="reply_item">';
                newlist += '<div class="reply_avatar"><img src="' + data.data[i].author_avatar_url + '?w=30&h=30&s=3" /></div>';
                newlist += '<div style="width: 100%;">';
                newlist += '<div class="reply_top">';
                newlist += '<div class="reply_name">' + data.data[i].author_nickname + '</div>';
                newlist += '<div class="reply_time">' + data.data[i].post_time + '</div>';
                newlist += '</div>';
                newlist += '<div class="reply_middle">';
                newlist += '<div class="reply_content">' + data.data[i].content + '</div>';

                newlist += '</div>';

                newlist += '</div>';
                newlist += '</div>';
            }

            ele.find('.reply_item').remove();
            ele.append(newlist);

            if (data.data.length < 5) {
                $('.more').css('display', 'none');
            }

            // replyPage++;
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined) {
                alert('获取评论列表失败:' + data.message);
            } else {
                alert('获取评论列表失败:' + data);
            }
        }
    });
}

function getRecommends() {
    $.ajax({
        type: 'get',
        async: false,
        url: ROOT + '/community/recommends',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data == '') {
                return;
            }
            if (data.message !== undefined) {
                // alert("操作失败:" + data.message);
                return;
            }
            if (data.data === undefined) {
                // alert("操作失败");
                return;
            }
            var newlist = '';
            for (var i = 0; i < data.data.length; i++) {
                var info = data.data[i];
                newlist += '<div class="recommends-item">';
                newlist += '<div class="recommends-item-title"><a href="' + info.url + '" target="_blank">' + info.title + '</a></div>';
                newlist += '<div class="recommends-item-time">' + info.publish_time + '</div>';
                newlist += '</div>';
            }

            $('.home-recommends .recommends-items').html(newlist);
        },
        error: function (data) {
            console.log(data);
            if (data.message !== undefined) {
                console.log('获取列表失败:' + data.message);
            } else {
                console.log('获取列表失败');
            }
        }
    });
}

$(document).on('click', '.thread-tool-jubao', function () {
    var id = $(this).data('id');
    var title = '';
    for (var i = 0; i < contentlist.length; i++) {
        var info = contentlist[i];
        if (info.id == id) {
            title = info.content;
        }
    }
    // var title = $(this).data('title');
    if (title.length == 0) {
        title = '举报';
    }
    var data = {
        'source': 'community',
        'type': 'thread',
        'source_id': id,
        'title': title
    };
    showReportDlg(3, data, function (id) {
        // 点击确认后调用, id是举报记录id
    });
});